module.exports = __webpack_public_path__ + "img/weekly.a0eb5c04.svg";